import * as types from '../mutation-types.js'

//全局状态
const state = {
  username: '',
  password: '',
  tabData: [],
  treeData: [],
  token: '',
  stafftype: '',
  limit:""
}

//getters 
const getters = {
  username: state => {
    return state.username
  },
  password: state => {
    return state.password
  },
  tabData: state => {
    return state.tabData
  },
  treeData: state => {
    return state.treeData
  },
  token: state => {
    return state.token
  },
  stafftype: state =>{
    return state,stafftype
  },
  limit: state =>{
    return state,limit
  },
}

const mutations = {
  [types.SET_USERNAME] (state, username) {
    state.username = username
  },
  [types.SET_PASSWORD] (state, password) {
  	state.password = password
  },
  [types.SET_TABDATA](state, tabData) {
    state.tabData = tabData
  },
  [types.SET_TREEDTA](state, treeData) {
    state.treeData = treeData
  },
  [types.SET_TOKEN](state, token) {
    state.token = token
  },
  [types.SET_STAFFTYPE](state, stafftype) {
    state.stafftype = stafftype
  },
  [types.SET_LIMIT](state, limit) {
    state.limit = limit
  },
}

export default {
  state,
  mutations,
  getters
}


// WEBPACK FOOTER //
// ./src/store/modules/common.js